// ════════════════════════════════════════════════════════════════════════════
//  features/fiscal/services/nfceService.ts
//
//  Cliente HTTP da emissão de NFC-e (modelo 65). A CONFIGURAÇÃO da NFC-e usa
//  configuracoesService (getConfigNfce/salvarConfigNfce, /api/config/nfce).
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  EmitirNfceRequest,
  EmitirNfceResponse,
  NfceListResponse,
  NfceDetalhe,
  ProximoNumeroNfce,
} from '../types';

const BASE = '/api/nfce';

export const nfceService = {
  async emitir(req: EmitirNfceRequest): Promise<EmitirNfceResponse> {
    const { data } = await apiClient.post<EmitirNfceResponse>(`${BASE}/emitir`, req);
    return data;
  },

  async cancelar(id: number, justificativa: string): Promise<EmitirNfceResponse> {
    const { data } = await apiClient.post<EmitirNfceResponse>(
      `${BASE}/${id}/cancelar`,
      { justificativa },
    );
    return data;
  },

  async consultar(id: number): Promise<EmitirNfceResponse> {
    const { data } = await apiClient.post<EmitirNfceResponse>(`${BASE}/${id}/consultar`);
    return data;
  },

  async detalhe(id: number): Promise<NfceDetalhe> {
    const { data } = await apiClient.get<NfceDetalhe>(`${BASE}/${id}`);
    return data;
  },

  /** Baixa o DANFE-NFCe (PDF térmico 80mm). Retorna Blob para download/print. */
  async obterDanfe(id: number): Promise<Blob> {
    const { data } = await apiClient.get(`${BASE}/${id}/danfe`, {
      responseType: 'blob',
    });
    return data as Blob;
  },

  async proximoNumero(): Promise<ProximoNumeroNfce> {
    const { data } = await apiClient.get<ProximoNumeroNfce>(`${BASE}/proximo-numero`);
    return data;
  },

  async listar(
    pagina = 1,
    tamanho = 30,
    inicio?: string,
    fim?: string,
  ): Promise<NfceListResponse> {
    const { data } = await apiClient.get<NfceListResponse>(BASE, {
      params: { pagina, tamanho, inicio, fim },
    });
    return data;
  },
};
